import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useTheme } from '@emotion/react';
// Mui components
import { Stack, Box, Typography, Breadcrumbs } from '@mui/material';
// Icons
import chevronRightBlue from '../../assets/icons/icon_chevron-right-blue.svg';

const stepsSolicitudDeConexion = [{ key: 1, value: "Inicio", status: "on" }, { key: 2, value: "Solicitud de conexión de agendas", status: "off" }];
const stepsConsultorios = [{ key: 1, value: "Mis consultorios", status: "on" }, { key: 2, value: "Consultorios", status: "on" }, { key: 3, value: "Detalle de consultorio", status: "off" }];
const stepsModificacionConsultorios = [{ key: 1, value: "Mis consultorios", status: "on" }, { key: 2, value: "Consultorios", status: "on" }, { key: 3, value: "Detalle de consultorio", status: "on" }, { key: 4, value: "Solicitud de modificación", status: "off" }];

export default function BreadcrumbsGeneric({ loader }) {
  const theme = useTheme();
  const location = useLocation();
  const routesWithBreadcrumbs = ['/prestador/registro', '/prestador/misConsultorios/:id', '/prestador/misConsultorios/:id/solicitarModificacion'];

  const showNavBar = loader === false && routesWithBreadcrumbs.some((route) => matchPath(route, location.pathname));

  const breadcrumbOptions = () => {
    if (location.pathname === '/prestador/registro') {
      return stepsSolicitudDeConexion.map((step) => (
        <Typography
          key={step.key}
          variant='bodyS'
          color={step.status === "on" ? theme.palette.primary.main : theme.palette.gray.main}
        >
          {step.value}
        </Typography>
      ));
    }
    if (matchPath('/prestador/misConsultorios/:id', location.pathname)) {
      return stepsConsultorios.map((step) => (
        <Typography
          key={step.key}
          variant='bodyS'
          color={step.status === "on" ? theme.palette.primary.main : theme.palette.gray.main}
        >
          {step.value}
        </Typography>
      ));
    }
    if (matchPath('/prestador/misConsultorios/:id/solicitarModificacion', location.pathname)) {
      return stepsModificacionConsultorios.map((step) => (
        <Typography
          key={step.key}
          variant='bodyS'
          color={step.status === "on" ? theme.palette.primary.main : theme.palette.gray.main}
        >
          {step.value}
        </Typography>
      ));
    }
  };

  const breadcrumb = breadcrumbOptions();

  return (showNavBar &&
    <Stack>
      <Breadcrumbs
        separator={
          <Box
            component="img"
            sx={{ width: "16px", height: "16px" }}
            alt="img not found"
            src={chevronRightBlue}
          />
        }
      >
        {breadcrumb}
      </Breadcrumbs>
    </Stack>
  );
}
